export const enum CookieKeys {
  LOGIN_CALLBACK = 'lcb',
}

export const enum QueryStringKeys {
  REDIRECT_URL = 'redirect_url',
  PROMO_CODE = 'code',
}

export const PROMO_CODE_DEFAULT_ID = 0

export const DEFAULT_DEBOUNCE = 500
